var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-page",attrs:{"df":"","fdc":""}},[_c('div',{staticClass:"tab-title"},[_vm._v("조직도")]),_c('div',{staticClass:"tab-content",attrs:{"flex":""}},[_c('organization-tree',{attrs:{"tooltip":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }